import { getBackendUrl } from './origin';
import { apiPost } from './publicApi';
const API = getBackendUrl();
const VAPID_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const arr = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) arr[i] = rawData.charCodeAt(i);
  return arr;
}

export async function registerPush(customerId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  if (!VAPID_KEY) return null;

  try {
    const reg = await navigator.serviceWorker.register('/sw-push.js');
    await navigator.serviceWorker.ready;

    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_KEY),
      });
    }

    await apiPost('/api/push/subscribe', { customer_id: customerId, subscription: subscription.toJSON() });

    return subscription;
  } catch (e) {
    console.error('Push registration failed:', e);
    return null;
  }
}

export async function unregisterPush(customerId) {
  if (!('serviceWorker' in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (!reg) return;
    const subscription = await reg.pushManager.getSubscription();
    if (!subscription) return;

    await apiPost('/api/push/unsubscribe', { customer_id: customerId, endpoint: subscription.endpoint });

    await subscription.unsubscribe();
  } catch (e) {
    console.error('Push unregister failed:', e);
  }
}

export async function isPushSubscribed() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    return !!sub;
  } catch { return false; }
}

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

async function _getPushSubscription() {
  const reg = await navigator.serviceWorker.register('/sw-push.js');
  await navigator.serviceWorker.ready;
  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_KEY),
    });
  }
  return subscription;
}

export async function registerRiderPush(riderToken) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  if (!VAPID_KEY || !riderToken) return null;
  try {
    const subscription = await _getPushSubscription();
    await fetch(`${API}/api/rider/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${riderToken}` },
      body: JSON.stringify({ subscription: subscription.toJSON() }),
    });
    return subscription;
  } catch (e) {
    console.error('Rider push registration failed:', e);
    return null;
  }
}
